import axios from "../axios";

const updateAbstractBH = (id, data) => {
  const promise = new Promise((resolve, reject) => {
    const url = `admin/abstract_bh/${id}`;
    axios
      .put(url, data)
      .then((res) => resolve(res.data))
      .catch((res) => {
        reject(res);
      });
  });

  return promise;
};

export default {
  updateAbstractBH,
};
